module.exports = __webpack_public_path__ + "img/btn_next.46634077.svg";